import { useTranslation } from "react-i18next";
import { cn } from "@v2/lib/utils";
import { rosterSections, type View } from "./nav-config";

// Sotto-sezioni della Rosa su telefono e tablet (su desktop stanno nella sidebar).
export function RosterTabs({ activeView, onSelect }: { activeView: View; onSelect: (view: View) => void }) {
  const { t } = useTranslation("shell");
  if (!rosterSections.some((s) => s.view === activeView)) return null;
  return (
    <div className="lg:hidden -mx-4 sm:-mx-6 px-4 sm:px-6 mb-4 flex gap-2 overflow-x-auto [scrollbar-width:none]">
      {rosterSections.map((section) => (
        <button
          key={section.id}
          type="button"
          onClick={() => onSelect(section.view)}
          className={cn("h-9 shrink-0 rounded-full px-4 text-sm transition-colors", activeView === section.view ? "bg-primary text-primary-foreground font-semibold" : "bg-raised text-muted-foreground")}
        >
          {t(section.labelKey)}
        </button>
      ))}
    </div>
  );
}
